var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge-row"},[_vm._l((_vm.attributes),function(attribute){return [_c('product-attribute-badge',{attrs:{"attribute":attribute}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }